import React from "react"
import { StyledPACBanner, StyledPACText } from "QuorumGrassroots/widgets/ReusableComponents/PACBanner/PACBanner.styles"
import { RequiredIcon } from "QuorumGrassroots/widgets/ReusableComponents/RequiredIcon/RequiredIcon"

const PACBanner: React.FC = () => {
    return (
        <StyledPACBanner>
            <StyledPACText>
                Fields marked with <RequiredIcon /> come from your PAC records. Need edits? Contact your PAC account
                manager.
            </StyledPACText>
        </StyledPACBanner>
    )
}

export default PACBanner
